import { Tab } from "@headlessui/react";
import { groupBy } from "lodash";

import { TabNoData } from "../../components/common/NoData";
import TextNavBackground from "../../components/common/TextNavBackground";
import FixtureResultCard from "../../components/elements/fixtures/FixtureResultCard";
import LeagueTable from "../../components/elements/standings/LeagueTable";
import { apiWrapper } from "../../utils/api/apiWrapper";
import {
  kPastSeasonListURL,
  kSeasonDetailURL,
} from "../../utils/constants/apiUrls";
import { GUEST_TOKEN } from "../../utils/constants/names";
import { TWELVE_MONTHS_REFRESH_INTERVAL_SECONDS } from "../../utils/constants/numbers";
import { customStaticSeoConfig } from "../../utils/helpers/helpers";
import { convertToMonth } from "../../utils/helpers/dateAndTime";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ArchiveDetail = ({ season }) => {
  const seasonTitle = season.season_title;
  const {
    academy_results: academyResults,
    men_results: menResults,
    women_results: womenResults,
  } = season.matches;

  const {
    academy_tables: academyTables,
    men_tables: menTables,
    women_tables: womenTables,
  } = season.tables;

  // GROUPED MEN
  const groupedMenResults = groupBy(menResults, (item) => convertToMonth(item));

  // GROUPED WOMEN
  const groupedWomenResults = groupBy(womenResults, (item) =>
    convertToMonth(item)
  );

  // GROUPED ACADEMY
  const groupedAcademyResults = groupBy(academyResults, (item) =>
    convertToMonth(item)
  );

  return (
    <>
      {customStaticSeoConfig(`${seasonTitle} Season Archives`)}

      <TextNavBackground title={`${seasonTitle} Season Archives`} />

      <div className="block w-full text-base sm:text-sm">
        <Tab.Group>
          <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto bg-gray-200">
            {/* <Tab
              className={({ selected }) =>
                classNames(
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                  selected
                    ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none"
                )
              }
            >
              Men
            </Tab>
            <Tab
              className={({ selected }) =>
                classNames(
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                  selected
                    ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none"
                )
              }
            >
              Women
            </Tab>
            <Tab
              className={({ selected }) =>
                classNames(
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                  selected
                    ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none"
                )
              }
            >
              Academy
            </Tab> */}
          </Tab.List>
          <Tab.Panels>
            {/* MEN MATCHES AND STANDINGS */}
            <Tab.Panel className="mt-5">
              {menResults.length !== 0 ||
              Object.keys(menTables).length !== 0 ? (
                <Tab.Group>
                  <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto">
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Matches
                    </Tab>
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Standings
                    </Tab>
                  </Tab.List>
                  <Tab.Panels>
                    {/** MEN TABLES MATCHES PANEL */}
                    <Tab.Panel>
                      <div className="mb-16">
                        {Object.keys(groupedMenResults).length !== 0 ? (
                          Object.keys(groupedMenResults).map((month, index) => {
                            return (
                              <>
                                <div key={month}>
                                  <h2 className="text-lg font-extrabold tracking-tight text-gray-400 text-center mt-20">
                                    {month}
                                  </h2>
                                  {groupedMenResults[month].map((result) => {
                                    return (
                                      <div key={result.id} className="mb-6">
                                        <FixtureResultCard result={result} />
                                      </div>
                                    );
                                  })}
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <TabNoData />
                        )}
                      </div>
                    </Tab.Panel>

                    {/** MEN TABLES TAB PANEL */}
                    <Tab.Panel>
                      <div className="mb-16">
                        {Object.keys(menTables).length === 0 && (
                          <>
                            <TabNoData />
                          </>
                        )}

                        {Object.keys(menTables).length !== 0 && (
                          <>
                            <div className="block w-full text-base sm:text-sm">
                              <Tab.Group>
                                <Tab.List className="-mb-px flex justify-start sm:justify-center items-center space-x-8 overflow-x-auto pl-14 pr-14">
                                  {Object.keys(menTables).map((table) => (
                                    <Tab
                                      key={table}
                                      className={({ selected }) =>
                                        classNames(
                                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none",
                                          selected
                                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                                            : "text-gray-500 hover:text-gray-700"
                                        )
                                      }
                                    >
                                      {table}
                                    </Tab>
                                  ))}
                                </Tab.List>
                                <Tab.Panels className="max-w-2xl mx-auto lg:max-w-7xl px-10">
                                  {Object.values(menTables).map(
                                    (table, index) => (
                                      <Tab.Panel key={index}>
                                        <LeagueTable table={table} />
                                      </Tab.Panel>
                                    )
                                  )}
                                </Tab.Panels>
                              </Tab.Group>
                            </div>
                          </>
                        )}
                      </div>
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group>
              ) : (
                <TabNoData />
              )}
            </Tab.Panel>

            {/* WOMEN FIXTURES AND RESULTS */}
            {/* <Tab.Panel className="mt-5">
              {/* {womenResults.length !== 0 ||
              Object.keys(womenTables).length !== 0 ? (
                <Tab.Group>
                  {/* <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto">
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Matches
                    </Tab>
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Standings
                    </Tab>
                  </Tab.List> */}
            <Tab.Panels>
              {/** WOMEN TABLES MATCHES PANEL */}
              {/* <Tab.Panel>
                      <div className="mb-16">
                        {Object.keys(groupedWomenResults).length !== 0 ? (
                          Object.keys(groupedWomenResults).map(
                            (month, index) => {
                              return (
                                <>
                                  <div key={month}>
                                    <h2 className="text-lg font-extrabold tracking-tight text-gray-400 text-center mt-20">
                                      {month}
                                    </h2>
                                    {groupedWomenResults[month].map(
                                      (result) => {
                                        return (
                                          <div key={result.id} className="mb-6">
                                            <FixtureResultCard
                                              result={result}
                                            />
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </>
                              );
                            }
                          )
                        ) : (
                          <TabNoData />
                        )}
                      </div>
                    </Tab.Panel> */}

              {/** WOMEN TABLES TAB PANEL */}
              <Tab.Panel>
                <div className="mb-16">
                  {/* {Object.keys(womenTables).length === 0 && (
                          <>
                            <TabNoData />
                          </>
                        )} */}

                  {/* {Object.keys(womenTables).length !== 0 && (
                          <>
                            <div className="block w-full text-base sm:text-sm">
                              <Tab.Group>
                                <Tab.List className="-mb-px flex justify-start sm:justify-center items-center space-x-8 overflow-x-auto pl-14 pr-14">
                                  {Object.keys(womenTables).map((table) => (
                                    <Tab
                                      key={table}
                                      className={({ selected }) =>
                                        classNames(
                                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none",
                                          selected
                                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                                            : "text-gray-500 hover:text-gray-700"
                                        )
                                      }
                                    >
                                      {table}
                                    </Tab>
                                  ))}
                                </Tab.List>
                                <Tab.Panels className="max-w-2xl mx-auto lg:max-w-7xl px-10">
                                  {Object.values(womenTables).map(
                                    (table, index) => (
                                      <Tab.Panel key={index}>
                                        <LeagueTable table={table} />
                                      </Tab.Panel>
                                    )
                                  )}
                                </Tab.Panels>
                              </Tab.Group>
                            </div>
                          </>
                        )} */}
                </div>
              </Tab.Panel>
            </Tab.Panels>
            {/* </Tab.Group>
              ) : (
                <TabNoData />
              )} */}
            {/* </Tab.Panel> */}

            {/* ACADEMY FIXTURES AND RESULTS */}
            {/* <Tab.Panel className="mt-5">
              {academyResults.length !== 0 ||
              Object.keys(academyTables).length !== 0 ? (
                <Tab.Group>
                  <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto">
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Matches
                    </Tab>
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none mb-6",
                          selected
                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                            : "text-gray-500 hover:text-gray-700"
                        )
                      }
                    >
                      Standings
                    </Tab>
                  </Tab.List>
                  <Tab.Panels>
                    {/** ACADEMY TABLES MATCHES PANEL */}
            {/* <Tab.Panel>
                      <div className="mb-16">
                        {Object.keys(academyResults).length !== 0 ? (
                          Object.keys(academyResults).map((month, index) => {
                            return (
                              <>
                                <div key={month}>
                                  <h2 className="text-lg font-extrabold tracking-tight text-gray-400 text-center mt-20">
                                    {month}
                                  </h2>
                                  {academyResults[month].map((result) => {
                                    return (
                                      <div key={result.id} className="mb-6">
                                        <FixtureResultCard result={result} />
                                      </div>
                                    );
                                  })}
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <TabNoData />
                        )}
                      </div>
                    </Tab.Panel> */}

            {/** MEN TABLES TAB PANEL */}
            {/* <Tab.Panel>
                      <div className="mb-16">
                        {Object.keys(academyTables).length === 0 && (
                          <>
                            <TabNoData />
                          </>
                        )}

                        {Object.keys(academyTables).length !== 0 && (
                          <>
                            <div className="block w-full text-base sm:text-sm">
                              <Tab.Group>
                                <Tab.List className="-mb-px flex justify-start sm:justify-center items-center space-x-8 overflow-x-auto pl-14 pr-14">
                                  {Object.keys(academyTables).map((table) => (
                                    <Tab
                                      key={table}
                                      className={({ selected }) =>
                                        classNames(
                                          "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none",
                                          selected
                                            ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                                            : "text-gray-500 hover:text-gray-700"
                                        )
                                      }
                                    >
                                      {table}
                                    </Tab>
                                  ))}
                                </Tab.List>
                                <Tab.Panels className="max-w-2xl mx-auto lg:max-w-7xl px-10">
                                  {Object.values(academyTables).map(
                                    (table, index) => (
                                      <Tab.Panel key={index}>
                                        <LeagueTable table={table} />
                                      </Tab.Panel>
                                    )
                                  )}
                                </Tab.Panels>
                              </Tab.Group>
                            </div>
                          </>
                        )}
                      </div>
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group>
              ) : (
                <TabNoData />
              )}
            </Tab.Panel> */}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </>
  );
};

export default ArchiveDetail;

export const getStaticProps = async (context) => {
  const token = process.env.GUSET_USER_TOKEN
    ? process.env.GUSET_USER_TOKEN
    : GUEST_TOKEN;

  const seasonSlug = context.params.slug;

  const season = await apiWrapper.get(
    kSeasonDetailURL + `?slug=${seasonSlug}`,
    token
  );

  return {
    props: {
      season: season?.data,
    },
    revalidate: TWELVE_MONTHS_REFRESH_INTERVAL_SECONDS,
  };
};

export async function getStaticPaths() {
  const token = process.env.GUSET_USER_TOKEN
    ? process.env.GUSET_USER_TOKEN
    : GUEST_TOKEN;

  const pastSeasons = await apiWrapper.get(kPastSeasonListURL, token);

  const pastSeasonsData = pastSeasons?.data;

  const paths = pastSeasonsData.map((season) => ({
    params: { slug: season.slug },
  }));

  return { paths, fallback: "blocking" };
}
